import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-upload-payment-document',
  templateUrl: './upload-payment-document.component.html',
  styleUrls: ['./upload-payment-document.component.scss'],
})
export class UploadPaymentDocumentComponent implements OnInit {
  files: any[] = [];
  supportedFiles: string = '.pdf,.jpg,.png,.jpeg,.doc,.docx,.bmp,.tiff,.tif';


  constructor(
    private UTS: UtilitiesService,
    private SS: SubjectService,
    private modalController: ModalController
  ) {}

  ngOnInit() {}

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  // uploadFilesSimulator(index: number) {
  //   setTimeout(() => {
  //     if (index === this.files.length) {
  //       return;
  //     } else {
  //       const progressInterval = setInterval(() => {
  //         if (this.files[index].progress === 100) {
  //           clearInterval(progressInterval);
  //           this.uploadFilesSimulator(index + 1);
  //         } else {
  //           this.files[index].progress += 5;
  //         }
  //       }, 200);
  //     }
  //   }, 1000);
  // }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      if (this.fileValidation(item)) {
        const reader = new FileReader();
        reader.readAsDataURL(item);
        reader.onload = () => {
          const data = reader.result;
          const payload = {
            document: data.toString().split(',')[1],
            documentName: item.name.split('.')[0],
            documentExtension: item.name.split('.').pop(),
          };
          
          this.files.push(payload);
          this.SS.uploadPaymentReceipt.next(payload);
          this.dismiss();
        };
      }
    }
  }

  fileValidation(file: any) {
    if (file) {
      if (file.name.toLowerCase().split('.').pop() !== 'pdf' && file.name.toLowerCase().split('.').pop() !== 'jpg' && file.name.toLowerCase().split('.').pop() !== 'doc'  && file.name.toLowerCase().split('.').pop() !== 'docx' && file.name.toLowerCase().split('.').pop() !== 'jpeg' && file.name.toLowerCase().split('.').pop() !== 'bmp' && file.name.toLowerCase().split('.').pop() !== 'tiff' && file.name.toLowerCase().split('.').pop() !== 'tif') {
        this.UTS.clearError();
        this.UTS.error('File type must be pdf, jpg, doc, bmp, tiff only');
        return false;
      }
      if (file.size && Number(file.size / 1024 / 1024) > 5) {
        this.UTS.clearError();
        this.UTS.error("File size shouldn't be greater than 5 MB ");
        return false;
      }
      return true;
    }
    return false;
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }
}
